"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* for direct usage */
var core_1 = require("./core");
exports.compress = core_1.compress;
exports.decompress = core_1.decompress;
/* for custom wrapper */
var core_2 = require("./core");
exports.decode = core_2.decode;
var memory_1 = require("./memory");
exports.addValue = memory_1.addValue;
/* to remove undefined object fields */
var helpers_1 = require("./helpers");
exports.trimUndefined = helpers_1.trimUndefined;
exports.trimUndefinedRecursively = helpers_1.trimUndefinedRecursively;
